import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManagePukalService } from '../../../../services/manage-pukal.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { WMSValidators } from '../../../../shared/validators';

@Component({
    selector: 'dialog-swk-add-new-account',
    templateUrl: 'dialog.addnewaccount.html',
    styleUrls: ['dialog.addnewaccount.css']
})
export class AddNewAccountPukalSarawakGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    isSubmit: boolean = false;
    addnewaccform: FormGroup;
    errorMessage: string = '';
    warrant_auth_code: string = 'SW';
    agencyCodes = [];
    accoffices = [];
    objects = [];
    activations = [];

    constructor(public dialogRef: MatDialogRef<AddNewAccountPukalSarawakGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private managePukalService: ManagePukalService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.addnewaccform = new FormGroup({
            selectedagency: new FormControl({ value: '', disabled: false }, Validators.required),
            pukalnumber: new FormControl({ value: '', disabled: true }),
            ptjCode: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(9)]),
            description: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(500)]),
            email: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.required, Validators.maxLength(50)]),
            selectedactivation: new FormControl({ value: '', disabled: false }, Validators.required)
        });

        let init_sub = this.managePukalService.getAddPukalAccountLoad(this.warrant_auth_code)
            .subscribe(
                (data) => {
                    this.agencyCodes = data.agentCodes;
                    this.activations = data.accountStatus;

                    this.addnewaccform.setValue({
                        selectedagency: data.agentCodes[0].Airline_Agency_Code,
                        pukalnumber: 'System Generate',
                        ptjCode: '',
                        description: '',
                        email: '',
                        selectedactivation: data.accountStatus[0].StatusCode
                    });
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(init_sub);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to add new Pukal Account?");

        if (cfm) {
            this.isSubmit = true;

            let newPukalAccount = {
                Airline_Agency_Code: this.addnewaccform.get('selectedagency')!.value,
                Description: this.addnewaccform.get('description')!.value,
                PTJ_Code: this.addnewaccform.get('ptjCode')!.value,
                Acc_Sts_Code: this.addnewaccform.get('selectedactivation')!.value,
                Email: this.addnewaccform.get('email')!.value
            }

            let save_sub = this.managePukalService.SWKAddNewPukalAccount(newPukalAccount)
                .subscribe(
                    (data) => {
                        this.dialogRef.close('Add new successful');
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}